import { render, staticRenderFns } from "./projectOverviewGC.vue?vue&type=template&id=53cc64c9&scoped=true&"
import script from "./projectOverviewGC.vue?vue&type=script&lang=js&"
export * from "./projectOverviewGC.vue?vue&type=script&lang=js&"
import style0 from "./projectOverviewGC.vue?vue&type=style&index=0&id=53cc64c9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc64c9",
  null
  
)

export default component.exports